import script from "./BaseAnchor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseAnchor.vue?vue&type=script&lang=ts&setup=true"

import "./BaseAnchor.vue?vue&type=style&index=0&id=6a2cc2b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2cc2b8"]])

export default __exports__